import { Component, Input, OnInit } from '@angular/core';
import { HighlightPropertyModel } from 'src/app/models/highlights-property.model';
import { PropertyService } from 'src/app/services/property.service';
import { SavedPropertiesService } from 'src/app/services/saved-properties.service';
import { UtilsPropertiesService } from 'src/app/services/utils-properties.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-popular-properties',
  templateUrl: './popular-properties.component.html',
  styleUrls: ['./popular-properties.component.css']
})
export class PopularPropertiesComponent implements OnInit {
  @Input() highlightsProperties: any[] = [];
  @Input() localAccommodations: any[] = [];
  activeDot: number = 0;
  activeDotLocal: number = 0;

  constructor(
    private propertyService: PropertyService,
    public savedService: SavedPropertiesService,
    public utilsPropertiesService: UtilsPropertiesService
  ) { }

  ngOnInit(): void {
  }

  priceFormat(propertyPrice: any, symbol: any = '€') {
    const spaces = (price: any) => String(price)
      .replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
      );
    return symbol + ' ' + spaces(propertyPrice);
  }

  saveProperty(reference: string) {
    this.savedService.saveProperty(reference);
  }

  changeDots(i: number, el: HTMLDivElement) {
    const width: any = document.getElementById('property-card-0')?.offsetWidth;
    const calc = i > 0 ? (i - 3) * width : i;
    el.style.transform = `translateX(-${calc}px)`;
    this.activeDot = i;
  }

  changeDotsLocal(i: number, el: HTMLDivElement) {
    const width: any = document.getElementById('property-local-card-0')?.offsetWidth;
    const calc = i > 0 ? (i - 3) * width : i;
    el.style.transform = `translateX(-${calc}px)`;
    this.activeDotLocal = i;
  }

}
